import React, { useState } from "react";
import { Card, Col, Form, Row, Upload } from "antd";
import { InboxOutlined, CloseOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { dispatch } from "../../../../redux/store";

import { openNotification } from "../../../../global/item/Notification/Notification";
import Loading from "../../../../global/item/Loading/loading";
import ButtonBottom from "../../../../global/item/ButtonComponent/ButtonBottom";
import { postImageAlbum } from "../../../../redux/action/image-album";

const { Dragger } = Upload;

function BannerCategoryCreateScreen() {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const [uploadedImages, setUploadedImages] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);

  // =========================
  // HANDLE FILE CHANGE
  // =========================
  const handleFileChange = (info: any) => {
    const files = info.fileList
      .map((item: any) => item.originFileObj)
      .filter(Boolean);

    const readers = files.map(
      (file: Blob) =>
        new Promise<string>((resolve) => {
          const reader = new FileReader();
          reader.onload = (e) => resolve(e.target?.result as string);
          reader.readAsDataURL(file);
        })
    );

    Promise.all(readers).then((images) => {
      setUploadedImages(images);
    });
  };

  // =========================
  // REMOVE IMAGE
  // =========================
  const handleRemoveImage = (index: number) => {
    setUploadedImages((prev) => prev.filter((_, i) => i !== index));
  };

  // =========================
  // SUBMIT
  // =========================
  const handleSubmit = async () => {
    setLoading(true);
    try {
      await form.validateFields();

      if (uploadedImages.length === 0) {
        openNotification({
          type: "warning",
          message: "Chưa chọn ảnh",
          description: "Vui lòng chọn ít nhất 1 ảnh!",
        });
        return;
      }

      // Upload từng ảnh lên Cloudinary
      const uploadPromises = uploadedImages.map(async (base64) => {
        const file = await fetch(base64).then((res) => res.blob());

        const formData = new FormData();
        formData.append("file", file);
        formData.append("upload_preset", "hoatuoi");

        const res = await fetch(
          "https://api.cloudinary.com/v1_1/dcxwarx50/image/upload",
          {
            method: "POST",
            body: formData,
          }
        );

        const data = await res.json();
        return { imgUrl: data.secure_url };
      });

      const payload = await Promise.all(uploadPromises);

      // POST mảng ảnh
      await dispatch(postImageAlbum(payload));

      openNotification({
        type: "success",
        message: t("update"),
        description: t("messUpdate"),
      });

      navigate("/home/collection");
    } catch (error) {
      console.error(error);
      openNotification({
        type: "error",
        message: "Lỗi",
        description: "Upload ảnh thất bại!",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <Form
          form={form}
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          autoComplete="off"
          requiredMark={false}
        >
          <Card className="layoutItem">
            <h3 style={{ color: "var(--primary-color)" }}>
              {t("imageInfo")}
            </h3>

            <Row gutter={[16, 16]} style={{ margin: "16px 0" }}>
              {uploadedImages.length > 0 ? (
                uploadedImages.map((img, index) => (
                  <Col xs={12} md={6} key={index}>
                    <div style={{ position: "relative" }}>
                      <CloseOutlined
                        onClick={() => handleRemoveImage(index)}
                        style={{
                          position: "absolute",
                          top: 8,
                          right: 8,
                          zIndex: 10,
                          cursor: "pointer",
                          color: "#fff",
                          background: "rgba(0,0,0,0.6)",
                          borderRadius: "50%",
                          padding: 4,
                        }}
                      />
                      <img
                        src={img}
                        alt={`preview-${index}`}
                        style={{
                          width: "100%",
                          height: 160,
                          objectFit: "cover",
                          borderRadius: 8,
                          border: "1px solid #eee",
                        }}
                      />
                    </div>
                  </Col>
                ))
              ) : (
                <Col span={24}>
                  <Form.Item
                    name="image"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng chọn ảnh!",
                      },
                    ]}
                  >
                    <Dragger
                      name="file"
                      multiple
                      showUploadList={false}
                      onChange={handleFileChange}
                    >
                      <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                      </p>
                      <p className="ant-upload-text">
                        {t("titleFile")}
                      </p>
                      <p className="ant-upload-hint">
                        {t("descFile")}
                      </p>
                    </Dragger>
                  </Form.Item>
                </Col>
              )}
            </Row>

            <p style={{ margin: 0 }}>{t("sizeIdeal")}: 1920 x 875</p>
          </Card>

          <ButtonBottom
            onContinueClick={handleSubmit}
            btnCancel={t("cancel")}
            btnContinue={t("continue")}
          />
        </Form>
      )}
    </div>
  );
}

export default BannerCategoryCreateScreen;
